import store from './store/index.js'
// 该文件是根据style匹配不同less文件的入口
// 注意引入所有对应匹配的变量文件在其他.vue与其他样式文件中不能应用该变量，
//公用的变量不是根据style匹配的可通过引用公用的common.less文件定义
function setTheme(name) {
  const body = document.querySelector('body')
  body.classList.add(name + '-theme')
  require(`./assets/common/${name}.less`)
}

const style = store.state.webInfo.style;
if (style && (style =="shaodong" || style =="taoyuan" || style=="huarong" || style =="anxiang" || style=="zhuzhou" || style == "yueyang")) {
  setTheme(style? style : 'shaodong')
} 




// WEBPACK FOOTER //
// ./src/commonStyleInit.js